import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { IncidentPlayerGuardian } from '../smart/incidentCreatedSuccessfully.interface';
import { LoggedInUser } from '../../../state/helperServices/auth/auth.interfaces';
import { AccountTypes } from '../../../components/changeUser/accountTypes.enum';

interface IncidentSuccessFullyCreatedMessageProps {
  user?: LoggedInUser;
  guardians?: IncidentPlayerGuardian[];
}

export const IncidentSuccessFullyCreatedMessage = ({
  user,
  guardians,
}: IncidentSuccessFullyCreatedMessageProps) => {
  const { t } = useTranslation();

  return (
    <>
      {/* created by the guardian */}
      {guardians &&
        guardians?.length === 1 &&
        user?.accountType !== AccountTypes.Guardian &&
        guardians[0]?.requestAccountType === AccountTypes.Org && (
          <Typography variant="h6" textAlign="center">
            {t('incident.INCIDENT_SUCCESSFULLY_CREATED', {
              name: `${user?.firstName.toString()} ${user?.lastName.toString()}`,
              playerGuardianEmail: [
                guardians?.map((guardian) => guardian.responseEmail),
              ],
            })}
          </Typography>
        )}
      {/* created by the guardian with no conneqtion */}
      {guardians && guardians?.length <= 0 && (
        <Typography variant="h6" textAlign="center">
          {t('incident.INCIDENT_SUCCESSFULLY_CREATED_NO_CONNECTION', {
            name: `${user?.firstName.toString()} ${user?.lastName.toString()}`,
          })}
        </Typography>
      )}
      {/* created with multiple conneqtions */}
      {guardians && guardians?.length > 1 && (
        <Typography variant="h6" textAlign="center">
          {t('incident.INCIDENT_SUCCESSFULLY_CREATED_MULTIPLE_GUARDIAN', {
            name: `${user?.firstName.toString()} ${user?.lastName.toString()}`,
          })}
        </Typography>
      )}
      {/* created with his own guardian */}
      {guardians &&
        guardians?.length === 1 &&
        user?.accountType === AccountTypes.Guardian && (
          <Typography variant="h6" textAlign="center">
            {t('incident.INCIDENT_SUCCESSFULLY_CREATED_BY_THE_GUARDIAN', {
              name: `${user?.firstName.toString()} ${user?.lastName.toString()}`,
            })}
          </Typography>
        )}
    </>
  );
};
